import type { IconSvgObject } from './types';

const Folder03Icon: IconSvgObject = [
  ["path", { d: "M3.66666 20.1961C3.76285 20.6635 4.18515 21 4.67564 21H18.5009C18.9553 21 19.3559 20.7103 19.4864 20.2873L21.9559 12.2873C22.154 11.6457 21.6596 11 20.9704 11H3.02931C2.37999 11 1.89299 11.5773 2.02033 12.1961L3.66666 20.1961Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 11L4 4C4 3.44772 4.44772 3 5 3H9.46482C9.79917 3 10.1114 3.1671 10.2969 3.4453L12 6M8.5 6H18C19.1046 6 20 6.89543 20 8V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Folder03Icon;
